<template>
  <div class="a-page">
    <div>
      <el-tag v-if="atosa_device === 'web'" style="margin-bottom: 30px" type="">
        {{ $t('tool.download_app_title') }}
        &nbsp;&nbsp;
        <a href="javascript:void(0)" style="text-decoration: underline !important;"
           @click="EB.$emit('show_download_app_dialog')">{{ $t('tool.download_app') }} !</a>
      </el-tag>

      <el-tabs v-model="tab">
        <el-tab-pane :label="$t('menu.ad_position_check')" name="spoil" style="padding: 0 5px">
        </el-tab-pane>
      </el-tabs>

      <br>

      <div style="display: inline-block; vertical-align: bottom; width: 30%;">
        <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword" class="full-w"
                         :fetch-suggestions="m__suggest_keyword" :disabled="loading"
                         @keyup.enter.native="m__search_products"></el-autocomplete>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div style="display: inline-block; vertical-align: bottom">
        <div class="x-box" :class="{'x-box-active': order_by_selected === 'relevancy'}"
             @click="m__select_order_by('pop')">
          {{ $t('tool.relevance') }}
        </div>
        <div class="x-box" :class="{'x-box-active': order_by_selected === 'ctime'}"
             @click="m__select_order_by('ctime')">
          {{ $t('tool.latest') }}
        </div>
        <div class="x-box" :class="{'x-box-active': order_by_selected === 'sales'}"
             @click="m__select_order_by('sales')">
          {{ $t('tool.top_sales') }}
        </div>

        <div style="clear:both"></div>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div style="display: inline-block">
        <el-button v-if="!loading" size="mini" type="primary" icon="el-icon-search" :loading="loading"
                   style="width: 200px" @click="m__search_products">
          {{ $t('base.search') }}
        </el-button>
        <el-button v-else size="mini" type="danger" @click="loading = false" style="width: 200px">
          <i class="el-icon-loading"></i> {{ $t('tool.click_to_stop') }}
        </el-button>
        <br>
        <div style="height: 2px;"></div>
      </div>

      <div style="margin-top: 40px">
        <el-row>
          <el-col :sm="12">
            <strong style="font-size: 16px">{{ $t('tool.ads_products') }}</strong>
          </el-col>
          <el-col :sm="12" class="text-right">
            <strong style="font-size: 13px;" class="text-danger">
              *{{ $t('tool.limit_x_message', {x: '30'}) }}.
            </strong>
          </el-col>
        </el-row>

        <div style="margin: auto; width: 100%; background-color: #f5f5f5; padding: 25px 10px 10px 15px">
          <div v-for="(item, index) in product_list" class="shopee-item"
               @click="open_link(`https://shopee.vn/product-i.${item.shopid}.${item.itemid}`)">
            <div class="shopee-item-content">
              <div class="shopee-item-img">
                <img :src="`https://cf.shopee.vn/file/${item.image}`">

                <div class="shopee-item-img-index">{{ index + 1 }}</div>
              </div>
              <div class="shopee-item-name">
                {{ item.name }}
              </div>
              <div class="shopee-item-price">
                <div v-if="+item.price_before_discount" class="shopee-item-before-price">
                  {{ item.price_before_discount / 100000 | currency }} đ
                </div>
                <div class="shopee-item-after-price">
                  {{ item.price / 100000 | currency }} đ
                </div>
                <div style="clear: both"></div>
              </div>
              <div class="shopee-item-info">
                {{ $t('metric.total_sold') }}: {{ m__short_value(item.historical_sold, false) }}
                <br>
                {{ $t('base.sales') }}:
                {{ item.sold ? m__short_value(Math.floor(item.price / 100000 * item.historical_sold), false) : 0 }}
                <br>
                {{ $t('tool.monthly_sold') }}: {{ m__short_value(item.sold, false) }}
                <br>
                {{ $t('tool.monthly_sales') }}: {{
                  item.sold ? m__short_value(Math.floor(item.price / 100000 * item.sold), false) : 0
                }}
                <br>
                {{ $t('tool.reviews') }}: {{
                  item.item_rating && item.item_rating.rating_count && item.item_rating.rating_count[0] ? item.item_rating.rating_count[0] : 0
                }}
                <br>
                Review / {{ $t('tool.buys') }}: {{
                  item.historical_sold && item.item_rating && item.item_rating.rating_count && item.item_rating.rating_count[0] ? (item.item_rating.rating_count[0] * 100 / item.historical_sold).toFixed(1) + '%' : 0
                }}
                <br>
                <el-rate
                  :value="item.item_rating ? +(item.item_rating.rating_star).toFixed(1) : 0"
                  disabled
                  show-score
                  text-color="#ff9900">
                </el-rate>
                -----------------------
                <br>
                {{ $t('tool.ads_type') }}: &nbsp;
                <span v-if="m__ads_type(item) === 'automatic'" class="text-primary"> {{ $t('base.automatic') }}</span>
                <span v-else class="text-warning"> {{ $t('base.manual') }}</span>
                <br>
                {{ $t('base.keyword') }}: &nbsp;<span class="text-warning"> {{ m__ads_keyword(item) }}</span>
                <i v-if="m__ads_keyword(item)" class="el-icon-copy-document"
                   @click.stop="copy_text(m__ads_keyword(item))"></i>
                <br>
                {{ $t('keyword.type') }}: &nbsp;<span class="text-warning"> {{ m__keyword_type(item) }}</span>
                <br>
                <el-button type="text" @click.stop="m__show_models_dialog(item)" :loading="loading_get_models"
                           :disabled="loading">
                  <strong class="text-primary">{{ $t('tool.show_variations') }}</strong>
                </el-button>
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog width="900px" :close-on-click-modal="false" :visible.sync="show_dialog.models"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>
        <strong>{{ $t('base.product') }}: {{ selected_product.name }}</strong>

        <br>
        <el-table
          v-loading="loading.get_models"
          :data="selected_models"
          style="width: 100%; margin-top: 10px; overflow-x: scroll">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            :label="$t('base.variations')"
            prop="name">
          </el-table-column>
          <el-table-column
            :label="$t('base.price')"
            prop="price" sortable>
            <template slot-scope="scope">
              {{ scope.row.price / 100000 | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sold')"
            prop="sold" sortable>
            <template slot-scope="scope">
              {{ scope.row.sold | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.sales')"
            prop="gmv" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv | currency }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('base.stock')"
            prop="price">
            <template slot-scope="scope">
              {{ scope.row.stock | currency }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="notify" :close-on-click-modal="false"
               custom-class="no-body"
               width="600px">
      <div slot="title" style="padding:10px">
        <div style="text-align: center">
          <strong style="font-size: 18px">{{ $t('base.notice') }}</strong>
        </div>

        <div style="margin-top: 30px; font-size: 14px; line-height: 25px">
          {{ $t('tool.download_app_message') }}
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="small" @click="EB.$emit('show_download_app_dialog'); notify = false">
            {{ $t('tool.download_app') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {check_channel, show_expr_notification} from '../../addon/check_license'
import {SPUserV4} from '../../addon/SPUserV4';

export default {
  name: 'page__spoil_position_ads',

  data() {
    return {
      tab: 'spoil',
      keyword: '',
      old_keyword: '',
      loading: false,
      device: 'website',
      product_list: [],
      order_by_selected: 'relevancy', // pop, ctime, sales
      shopee_account_list: [],
      show_dialog: {
        models: false
      },
      loading_get_models: false,
      selected_product: {},
      selected_models: [],

      channel: 'shopee_analysis_spoiler',
      feature: 'ads_analysis',
      limit_request_number: 0,
      current_request_number: 0,

      notify: false
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_channel(['shopee_marketing_survey', 'shopee_analysis_spoiler'])) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  beforeMount() {
    this.notify = this.atosa_device === 'web'

    this.m__get_shopee_account()
    this.m__get_limit_request_number()
  },

  methods: {
    async m__get_limit_request_number() {
      const package_found = this.$store.state.package.extend_package.find(i => i.channel === this.channel)
      if (package_found && package_found.package.extra_data.request_limit) {
        this.limit_request_number = package_found && package_found.package.extra_data.request_limit
      }
      console.log('limit_request_number', this.limit_request_number)

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/get', {
        channel: this.channel,
        feature: this.feature
      }, this.cf())
      this.current_request_number = response.body.data.count
      console.log('current_request_number', this.current_request_number)
    },

    async m__show_models_dialog(product) {
      this.selected_product = product
      this.selected_models = []

      if (!product.get_models) {
        this.loading_get_models = true
        try {
          // const response = await this.get_item({shop_id: product.shopid, item_id: product.itemid})
          const response = await this.xget_shopee(`/api/v4/pdp/get_pc?shop_id=${product.shopid}&item_id=${product.itemid}&detail_level=0`, {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "PDP.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          })
          if (!response || !response.data || !response.data.data || !response.data.data.data) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading_get_models = false
            return
          }

          // console.log(response)
          for (const item of response.data.data.data.item.models) {
            item.gmv = item.price / 100000 * item.sold
          }
          this.selected_models = response.data.data.data.item.models
          this.show_dialog.models = true
        } catch (e) {
          console.error(e)
        } finally {
          this.loading_get_models = false
        }
      }
    },

    async m__get_shopee_account() {
      try {
        const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/shopee_account/get', this.cf())
        this.shopee_account_list = response.body.data
        console.log(this.shopee_account_list)
      } catch (e) {
        console.error(e)
      }
    },

    async m__suggest_keyword(queryString, cb) {
      cb([])
      return

      if (!queryString) {
        cb([])
        return
      }
      const hint_keywords = await this.request_to_shopee({
        url: `https://shopee.vn/api/v4/search/search_hint?keyword=${encodeURIComponent(queryString)}&search_type=0&version=1`
      })
      if (hint_keywords && hint_keywords.body && hint_keywords.body.data && hint_keywords.body.data.keywords) {
        cb(hint_keywords.body.data.keywords.map(i => ({value: i.keyword})))
      } else {
        cb([])
      }
    },

    m__select_order_by(value) {
      if (this.loading) {
        return
      }

      this.order_by_selected = value
    },

    m__ads_type(row) {
      if (!row.ads_keyword || row.ads_keyword.includes('wkdaelpmiss')) {
        return 'automatic'
      } else {
        return 'manual'
      }
    },

    m__keyword_type(row) {
      if (this.m__ads_type(row) === 'manual') {
        if (this.old_keyword.startsWith(row.ads_keyword.normalize())) {
          row.ads_keyword = this.old_keyword
          return this.$t('base.exact')
        } else if (this.remove_unicode(this.old_keyword).startsWith(this.remove_unicode(row.ads_keyword.normalize()))) {
          row.ads_keyword = this.remove_unicode(this.old_keyword)
          return this.$t('base.exact')
        } else {
          return this.$t('base.broad')
        }
      }
    },

    m__ads_keyword(row) {
      if (this.m__ads_type(row) === 'thủ công') {
        return row.ads_keyword
      }
    },

    m__short_value(value, is_percent) {
      if (!value) return '0'
      if (!Number(value)) return '0.00'
      if (!is_percent) value = Math.floor(value)

      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''
      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return `${result} ${is_percent ? '%' : ''}`
    },

    async m__search_products() {
      if (this.limit_request_number && this.current_request_number >= this.limit_request_number) {
        this.ntf_w(this.$t('tool.limit_package_message'))
        return
      }

      if (!this.keyword) return

      if (this.loading) return

      this.old_keyword = this.keyword

      this.loading = true
      this.product_list = []

      try {
        let repeat = 0, max_repeat = 3
        const view_session_id = this.make_view_session_id()
        const query = {
          by: this.order_by_selected,
          keyword: encodeURIComponent(this.keyword.normalize()),
          newest: 0,
          limit: 60,
          order: 'desc',
          page_type: 'search',
          scenario: 'PAGE_GLOBAL_SEARCH',
          version: 2,
          view_session_id
        }
        // let response = await this.m__get_data(newest, limit, this.keyword, view_session_id)
        let path = '/api/v4/search/search_items?' + Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
        let response = await this.xget_shopee(path, {
          "antiFraudConfig": {
            "antiCrawler": {
              "appKey": "Search.PC",
              "shouldReplaceHistory": true,
              "redirectType": "1"
            },
            "deviceFingerPrint": {},
            "apiProtection": {}
          }
        })
        if (!response || !response.data) {
          this.ntf_w(this.$t('tool.cannot_get_data'))
          this.loading = false
          return
        }

        if (!response.data.data || !response.data.data.items) {
          this.ntf_w(this.$t('tool.cannot_get_data'))
          this.loading = false
          return
        }

        // console.log(response)
        response = {body: response.data}

        while (this.loading && response && response.body && response.body.data && response.body.data.items && response.body.data.items.length && query.newest <= 120) {
          for (const item of response.body.data.items) {
            if (!item.adsid) continue

            try {
              if (repeat <= max_repeat) {
                Object.assign(item, item.item_basic)
              }
            } catch (e) {
              repeat++
            }

            this.product_list.push(item)

            await this.sleep(200)
          }

          query.newest += query.limit
          path = '/api/v4/search/search_items?' + Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
          response = await this.xget_shopee(path, {
            "antiFraudConfig": {
              "antiCrawler": {
                "appKey": "Search.PC",
                "shouldReplaceHistory": true,
                "redirectType": "1"
              },
              "deviceFingerPrint": {},
              "apiProtection": {}
            }
          })
          if (!response || !response.data) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading = false
            return
          }

          if (!response.data.data || !response.data.data.items) {
            this.ntf_w(this.$t('tool.cannot_get_data'))
            this.loading = false
            return
          }

          // console.log(response)
          response = {body: response.data}

          await this.sleep(1000)
        }

        this.ntf_s(this.$t('tool.analyze_success'))

        if (this.product_list.length) {
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/limit_request/save', {
            channel: this.channel,
            feature: this.feature
          }, this.cf())
          await this.m__get_limit_request_number()
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading = false
      }
    },

    async m__get_data(newest = 0, limit = 60, keyword, view_session_id) {
      return await this.search_items({
        qs: {
          by: this.order_by_selected,
          keyword: keyword.normalize(),
          limit,
          newest,
          order: 'desc',
          page_type: 'search',
          view_session_id
        },
        device: this.device,
        cookie: this.shopee_account_list.length ? this.shopee_account_list[0].cookie : null
      }, true)
    },

    async m__get_product_detail(itemid, shopid) {
      const response = await this.request_to_shopee({
        url: `https://shopee.vn/api/v4/item/get?itemid=${itemid}&shopid=${shopid}`
      })
      if (response.body.data && response.body.data.data) {
        return response.body.data.data
      }

      return null
    }
  }
}
</script>

<style lang="scss">
.shopee-item {
  width: 19.7%;
  height: 565px;
  margin: 0 3px 0 0;
  padding: 0 5px 15px 5px;
  display: inline-block;
  cursor: pointer;
  overflow: hidden;
}

.shopee-item-content {
  background-color: white;
  height: 100%;
  padding: 10px;
}

.shopee-item-img {
  width: 100%;
  height: 200px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .shopee-item-img-index {
    top: 10px;
    left: 10px;
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    border: 1px solid black;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    line-height: 27px;
  }
}

.shopee-item-name {
  width: 100%;
  height: 35px;
  word-wrap: break-word;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.shopee-item-price {
  width: 100%;
  height: 35px;
  padding-top: 5px;

  .shopee-item-before-price {
    display: inline-block;
    font-size: 13px;
    color: rgba(0, 0, 0, .54);
    text-decoration: line-through;
  }

  .shopee-item-after-price {
    padding-left: 5px;
    display: inline-block;
    font-size: 14px;
    color: #ee4d2d;
    font-weight: 600;
  }
}

.shopee-item-info {
  width: 100%;
  height: auto;
  padding-top: 5px;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, .87);
  line-height: 20px;

  span {
    font-size: 12px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tool/spoil.vue